import React from 'react';
import { Link } from 'react-router-dom';
import Immutable from 'immutable';
import HowItWorksComponent from '../components/home/how_it_works';

export default class LandingImproveVocabulary extends React.Component {
  render() {
    return(
      <div className='landing col-sm-12'>
        <div className='row'>
          { this.renderOurFavorites() }
        </div>
        <HowItWorksComponent user={ Immutable.fromJS({ loggedIn: false }) }/>
      </div>
    );
  }

  renderOurFavorites() {
    return (
      <div className='all-trending-words'>
        <h1>
          Improve your vocabulary.
        </h1>
        <p>
          These are our ten favorite, underused English words. Use Yak Tack to remember them and improve your vocabulary!
        </p>
        <ol>
          <li>
            { this.renderFavorite('perfunctory', "Useful when describing situations like when you great your co-workers on Mondays. \"How was your weekend?\" is a question we might describe as a \"perfunctory nicety.\"") }
          </li>
          <li>
            { this.renderFavorite('apocraphyl', "Stories your grandfather tells you about walking to school up hill both ways. They're likely untrue but regarded by your family as authentic.") }
          </li>
          <li>
            { this.renderFavorite('extemporaneous', "When you do a great job leading a meeting you forgot to prepare for. One could say your performance was \"extemporaneous.\"") }
          </li>
          <li>
            { this.renderFavorite('obsequious', "One NY Times writer used this word to describe the relationship betwen President Trump and Vladimir Putin.") }
          </li>
          <li>
            { this.renderFavorite('sartorial', "Instead of saying \"I like your outfit,\" say \"Nice sartorial selection!\"") }
          </li>
          <li>
            { this.renderFavorite('fecund', "A great alternative to the word \"fruitful.\"") }
          </li>
          <li>
            { this.renderFavorite('pithy', "Don't call something \"short and sweet.\" Call it \"pithy.\"") }
          </li>
          <li>
            { this.renderFavorite('capricious', "Steve Jobs was said to be prone to sudden changes in mood. People who knew him said he was \"capricious.\"") }
          </li>
          <li>
            { this.renderFavorite('apotheosis', "Star Wars was the apotheosis of Mark Hammil's career. Use it intead of \"high point\" or \"climax.\"") }
          </li>
          <li>
            { this.renderFavorite('erudite', "The owl wasn't wise. It was \"erudite.\"") }
          </li>
        </ol>
      </div>
    );

  }

  renderFavorite(wordText, explanation) {
    return (
      <div className='trending-word'>
        <div>
          <Link to={ `/words/${wordText}` } className='word-text'>{ wordText }</Link>
        </div>
        <p>
          { explanation }
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing_improve_vocabulary.jsx